export function navigateToHome(err) {
  // console.log(err);
  window.location = "/";
};

export function navigateToLink(link) {
  window.location = link;
}